export namespace TreatsActions {
    export class FetchAll {
        static readonly type = '[TREATS] Fetch All'
    }

    export class Reset {
        static readonly type = '[TREATS] Reset'
    }
}